import React from 'react'
import { Button } from '../../../component'
import "./textdivcomp.css"
const DEFAULT_BODY =
  "Once you’ve completed the courses, learn from our quick design and code tutorials to strengthen your knowledge.";

export default function Textdivcomp({ btnimg, btntext, Heading, body, top, colors, left, data_aos }) {
  const styles = {
    subHeading: {
      fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)",
      fontWeight: 700,
      lineHeight: 1.15,
      letterSpacing: "-0.01em",
      margin: 0,
      color: colors,
    },
  };
  return (
    <div
      data-aos={data_aos}
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="1000"
      className='TextDivComp' style={{ top: top ? top : 0, left: left ? left : 0 }} >

      <p style={styles.subHeading}>{Heading}</p>
      <p style={{ fontSize: "0.95rem", lineHeight: 1.6, color: colors, fontWeight: 400, opacity: 0.75, margin: "12px 0 0" }}>
        {body || DEFAULT_BODY}
      </p>
      <Button img={btnimg} top={20} btntext={btntext} />
    </div>
  )
}
